import { ComponentType, lazy, LazyExoticComponent } from 'react';
import {
  isChunkLoadError,
  reloadOnceForChunkError,
} from './chunk-load-error.util';

export async function importWithPendingRetry<T>(
  factory: () => Promise<T>,
): Promise<T> {
  try {
    return await factory();
  } catch (error) {
    if (!isChunkLoadError(error)) {
      throw error;
    }
    await new Promise((resolve) => window.setTimeout(resolve, 250));
    return factory();
  }
}

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      return await importWithPendingRetry(factory);
    } catch (error) {
      if (isChunkLoadError(error) && reloadOnceForChunkError()) {
        return { default: (() => null) as unknown as T };
      }
      throw error;
    }
  });
}
